import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorage } from '../misc/localStorage';
import { LocalStorageEnum } from '../misc/enums';

@Injectable()
export class LangInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const lang = LocalStorage.getFromStorage(LocalStorageEnum.Locale) || 'es-mx';

    request = request.clone({
      setHeaders: {
        'Accept-Language': lang
      }
    });

    return next.handle(request);
  }
}
